import React from "react";
const AuditCell = ({ audit }) => {
    return React.createElement(React.Fragment, null, audit.present ? "Yes" : "--");
};
export default AuditCell;
//# sourceMappingURL=AuditCell.js.map